import { EditRoomType } from '@/hooks/use-edit-guest-rooms'
import { AdminReservationResponseType } from '@/models/reservation/admin-reservation'

// 部屋数（currentRoomNum）は、バックエンドがその部屋タイプの記録が2件以上のときだけ返すので、1部屋・1泊の予約には無い。
// 記録の数を泊数で割った値なので、部屋ごとに泊数が違うと端数が出る
type ReservationRoomRecord = Pick<
  AdminReservationResponseType['reservations']['reservationRoom'][number],
  'guestRoomAssignId' | 'typeNameJa' | 'typeNameEn' | 'roomTypeId'
> & { currentRoomNum?: number }

export const hasUnassignedReservationRoom = (reservationRoom: ReservationRoomRecord[] = []) =>
  reservationRoom.some(room => !room.guestRoomAssignId)

/**
 * 申し込みの記録に部屋がまだ割り当てられていないものがあれば、記録ごとの部屋数の分だけ部屋を並べる。
 * 右パネルが足す部屋と、表を動かす先の部屋タイプを、同じ条件で求めるために使う
 */
export const listReservationRoomsToAssign = (reservationRoom: ReservationRoomRecord[] = []): EditRoomType[] => {
  if (!hasUnassignedReservationRoom(reservationRoom)) return []
  return reservationRoom.flatMap(({ typeNameJa, typeNameEn, roomTypeId, currentRoomNum = 0 }) =>
    Array.from({ length: Math.ceil(currentRoomNum) }, () => ({ typeNameJa, typeNameEn, roomTypeId, guestRoomId: null, roomNumber: null })),
  )
}
